import React from "react";
import { translations } from "../containers/assets/translations";
import { Button, FormGroup, FormControl, ControlLabel } from "react-bootstrap";

export default class ChangePassword extends React.Component {
  //This component is used when the user navigates to the change password page.
  constructor(props) {
    super(props);
    this.onClick = this.onClick.bind(this);
    this.handleChange = this.handleChange.bind(this);
    this.onCloseModal = this.onCloseModal.bind(this);
    this.state = {
      openError: false,
      language: this.props.lang,
      form: {
        oldPassword: "",
        newPassword: "",
        newConfirmedPassword: ""
      },
      isButtonDisabled: true
    };
  }

  handleChange = event => {
    //Enable the button when the user has inserted data.
    let fieldName = event.target.name;
    let fieldVal = event.target.value;
    this.setState({ form: { ...this.props.form, [fieldName]: fieldVal } });

    if (
      this.props.form.oldPassword === "" ||
      this.props.form.newPassword === "" ||
      this.props.form.newConfirmedPassword === ""
    ) {
      this.setState({ isButtonDisabled: true });
    } else {
      this.setState({ isButtonDisabled: false });
    }
  };

  onCloseModal = () => {
    this.setState({ openError: false });
  };

  onClick = () => {
    //Check if new password is a valid one.
    if (this.props.form.newPassword !== this.props.form.newConfirmedPassword) {
      this.setState({ openError: true });
    }
  };

  render() {
    return (
      <div className="Login main">
        <form>
          <FormGroup bsSize="large">
            <ControlLabel>
              {translations[this.props.lang]["Old Password"]}
            </ControlLabel>
            <FormControl
              name="oldPassword"
              className="well"
              value={this.state.form.oldPassword}
              autoFocus
              autoComplete="new-password"
              type="password"
              onChange={event => {
                this.handleChange(event);
              }}
            />
          </FormGroup>
          <FormGroup bsSize="large">
            <ControlLabel>
              {translations[this.state.language]["New Password"]}
            </ControlLabel>
            <FormControl
              name="newPassword"
              className="well"
              value={this.state.form.newPassword}
              autoFocus
              autoComplete="new-password"
              type="password"
              onChange={event => {
                this.handleChange(event);
              }}
            />
          </FormGroup>
          <FormGroup bsSize="large">
            <ControlLabel>
              {translations[this.state.language]["Confirm New Password"]}
            </ControlLabel>
            <FormControl
              name="newConfirmedPassword"
              className="well"
              value={this.state.form.newConfirmedPassword}
              autoFocus
              autoComplete="new-password"
              type="password"
              onChange={event => {
                this.handleChange(event);
              }}
            />
          </FormGroup>

          <Button
            block
            className="btn btn-primary"
            bsSize="large"
            disabled={this.state.isButtonDisabled}
            type="button"
            onClick={() => {
              this.onClick();
            }}
          >
            {translations[this.state.language]["Change Password"]}
          </Button>
        </form>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/ChangePassword.js